import { ENDPOINT } from "../../network/ENDPOINT";
import { callApiToServer, callGetApiToServer, putApiToServer } from "../callApi";

function resolveToken(authToken) {
  if (authToken && typeof authToken === "string" && authToken.trim()) {
    return authToken.trim();
  }
  try {
    const rawState = localStorage.getItem("state");
    if (rawState) {
      const parsed = JSON.parse(rawState);
      const token =
        parsed?.auth?.authToken ||
        parsed?.auth?.token ||
        parsed?.auth?.admin_token;
      if (token && typeof token === "string" && token.trim()) {
        return token.trim();
      }
    }
  } catch (e) {}
  return (
    localStorage.getItem("admin_token") ||
    localStorage.getItem("token") ||
    ""
  );
}

function buildHeaders(authToken) {
  const token = resolveToken(authToken);
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    authorization: "Bearer " + token,
  };
}

/**
 * Fetch all electricity packages configured in the system
 */
export async function fetchElectricityPackagesAPI(authToken) {
  try {
    const headers = buildHeaders(authToken);
    return await callGetApiToServer(headers, "GET", ENDPOINT.electricity_packages);
  } catch (err) {
    throw err;
  }
}

/**
 * Update an electricity package pricing, denomination, or active state
 */
export async function updateElectricityPackageAPI(authToken, packageId, data) {
  try {
    const headers = buildHeaders(authToken);
    const body = JSON.stringify(data);
    const url = `${ENDPOINT.electricity_packages}/${packageId}`;
    return await putApiToServer(body, headers, "PUT", url);
  } catch (err) {
    throw err;
  }
}

/**
 * Sync package definitions from upstream Khales provider
 */
export async function syncElectricityPackagesAPI(authToken) {
  try {
    const headers = buildHeaders(authToken);
    const body = JSON.stringify({});
    return await callApiToServer(body, headers, "POST", ENDPOINT.electricity_packages_sync);
  } catch (err) {
    throw err;
  }
}

/**
 * Fetch paginated electricity transactions with filters
 */
export async function fetchElectricityTransactionsAPI(authToken, params = {}) {
  try {
    const headers = buildHeaders(authToken);
    const query = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
        query.append(key, params[key]);
      }
    });
    const qs = query.toString();
    const url = qs ? `${ENDPOINT.electricity_transactions}?${qs}` : ENDPOINT.electricity_transactions;
    return await callGetApiToServer(headers, "GET", url);
  } catch (err) {
    throw err;
  }
}

/**
 * Recheck upstream provider status for a pending electricity transaction
 */
export async function recheckElectricityTransactionAPI(authToken, transactionId) {
  try {
    const headers = buildHeaders(authToken);
    const body = JSON.stringify({});
    const url = `${ENDPOINT.electricity_transactions}/${transactionId}/recheck`;
    return await callApiToServer(body, headers, "POST", url);
  } catch (err) {
    throw err;
  }
}

/**
 * Manually resolve an electricity transaction under review
 */
export async function resolveElectricityTransactionAPI(
  authToken,
  transactionId,
  { resolution, token, audit_note, reference_id }
) {
  try {
    const headers = buildHeaders(authToken);
    const body = JSON.stringify({
      resolution,
      token,
      audit_note,
      reference_id,
    });
    const url = `${ENDPOINT.electricity_transactions}/${transactionId}/resolve`;
    return await callApiToServer(body, headers, "POST", url);
  } catch (err) {
    throw err;
  }
}
